// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2dEkn","imageUploader":"EGiftCard_imageUploader__2sdAM"};